import { cn } from "@gettactic/helpers";
import React from "react";

export const VirtualizedListRow = React.memo(
  ({ index, style, data }: VirtualizedListRowProps) => {
    const { childrenArray, itemClassName, firstItemRef } = data;
    const child = childrenArray[index];

    if (!child) {
      return null;
    }

    return (
      <div
        key={index}
        style={style}
        ref={index === 0 ? firstItemRef : undefined}
        className={cn(
          index < childrenArray.length - 1 && "border-neutral-200 border-b",
          itemClassName
        )}
      >
        {child}
      </div>
    );
  },
  (prevProps, nextProps) => {
    // Optimized comparison - only check essential props
    if (prevProps.index !== nextProps.index) {
      return false;
    }

    if (
      prevProps.data.childrenArray.length !==
      nextProps.data.childrenArray.length
    ) {
      return false;
    }

    // Only compare the specific child at this index
    const prevChild = prevProps.data.childrenArray[prevProps.index];
    const nextChild = nextProps.data.childrenArray[nextProps.index];

    return prevChild === nextChild;
  }
);

interface VirtualizedListRowProps {
  index: number;
  style: React.CSSProperties;
  data: {
    childrenArray: React.ReactNode[];
    itemClassName?: string;
    firstItemRef: React.RefObject<HTMLDivElement>;
  };
}
